import React from 'react';
import Shiitake from 'shiitake';
import PropTypes from 'prop-types';

const AspectRatioCardText = ({text}) => (
    <Shiitake lines={2} throttleRate={200} className="small" tagName="span">
        {text}
    </Shiitake>
);

AspectRatioCardText.propTypes = {
    /** The text to display. Text will be truncated as necessary. */
    text: PropTypes.string.isRequired
};

export default AspectRatioCardText;
